import React from "react";
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

const StyleTypeSelector = (props) => {
    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    return <div>
        <Select style={{backgroundColor:'#ffffff'}}
            size='small'
            value={props.value}
            onChange={(e)=>{props.onChange(e.target.value)}}
        >
            {
                props.styleTypes.map(s=>{
                    return <MenuItem key={s} value={s}>{capitalizeFirstLetter(s)}</MenuItem>
                })
            }
        </Select>
    </div>
}


export default StyleTypeSelector;